import { schema } from "normalizr";
import { PageLayoutComponentSchema } from "./page-layout-component";

export const PageLayoutComponentsSchema = new schema.Array(PageLayoutComponentSchema);
